/**
 * @fileoverview POST handler for the "/email/ip_warming/:app_group_id/engagement_data/begin_upload" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { emailIpWarmingAppGroupIdEngagementDataBeginUploadCacheKeys } from "./constants";
import type {
  PostEmailIpWarmingAppGroupIdEngagementDataBeginUploadProps,
  EmailIpWarmingAppGroupIdEngagementDataBeginUploadResult,
  PostEmailIpWarmingEngagementDataResultErrors,
} from "./types";

export const postEmailIpWarmingAppGroupIdEngagementDataBeginUpload = reactQueryMutationAdapter(
  emailIpWarmingAppGroupIdEngagementDataBeginUploadCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostEmailIpWarmingEngagementDataResultErrors>()(
    (
      props: PostEmailIpWarmingAppGroupIdEngagementDataBeginUploadProps
    ): Promise<EmailIpWarmingAppGroupIdEngagementDataBeginUploadResult> => {
      const { appGroupId, planId, ...requestBody } = props;

      return fetch(
        `/email/ip_warming/${appGroupId}/engagement_data/begin_upload/${planId}`,
        "POST",
        requestBody,
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
